export const bytesPerCommitment=48;export const bytesPerProof=48;export const versionedHashVersionKzg=1;